<template>
    <SideNav></SideNav>
    <router-view />
</template>

<script>
    import { defineComponent } from 'vue';
    import SideNav from './components/SideBarNav.vue';

    export default defineComponent({
        name: "nav",
        components: {
            SideNav
       
        },
    setup() {
    
    },
})
</script>

<style lang="scss">
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: var(--clr-black);
    }

</style>
